import '../globals';

;(function ($, moment) {
    'use strict';

    var pluginName = 'dateTimePicker',
        defaults = {
            format: 'DD.MM.YYYY HH:mm',
            useDefaultDate: false,
            minDate: moment().add(1, 'day'),
            maxDate: false,
            minTime: false,
            maxTime: false,
            disabledHours: false,
            daysOfWeekDisabled: [0, 6],
        };

    if ($('html').attr('lang') == 'de') {

        defaults['tooltips'] = {
            today: 'Gehe zu heute',
            clear: 'Auswahl löschen',
            close: 'Picker schließen',
            selectMonth: 'Monat auswählen',
            prevMonth: 'vorheriger Monat',
            nextMonth: 'nächster Monat',
            selectYear: 'Jahr auswählen',
            prevYear: 'Vorheriges Jahr',
            nextYear: 'Nächstes Jahr',
            selectDecade: 'Jahrzehnt auswählen',
            prevDecade: 'Vorheriges Jahrzehnt',
            nextDecade: 'Nächstes Jahrzehnt',
            prevCentury: 'Vorheriges Jahrhundert',
            nextCentury: 'Nächstes Jahrhundert',
            pickHour: 'Stunde wählen',
            incrementHour: 'Sunde erhöhen',
            decrementHour: 'Stunde verringern',
            pickMinute: 'Minute wählen',
            incrementMinute: 'Minute erhöhen',
            decrementMinute: 'Minute verringern',
            pickSecond: 'Sekunde wählen',
            incrementSecond: 'Sekunde erhöhen',
            decrementSecond: 'Sekunde verringern',
            togglePeriod: 'Zeit umstellen',
            selectTime: 'Zeit auswählen'
        }
    }

    function Plugin(element, options) {
        this.element = $(element);
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();

        return this;
    }

    $.extend(Plugin.prototype, {
        /**
         * Init
         */
        init: function () {
            // Overwrite the selectable time range if the settings minTime and maxTime are set
            if (this.settings.minTime && this.settings.maxTime) {
                let disabledHours = [];

                const now = new Date();
                const nowDateTime = now.toISOString();
                const nowDate = nowDateTime.split('T')[0];

                const startHour = new Date(nowDate + 'T' + this.settings.minTime).getHours();
                const endHour = new Date(nowDate + 'T' + this.settings.maxTime).getHours();

                for (let start = 0; start < startHour; start++) {
                    disabledHours.push(start);
                }
                for (let end = endHour; end < 24 && endHour !== 23; end++) {
                    disabledHours.push(end);
                }

                this.settings.disabledHours = disabledHours;
            }

            this.element.datetimepicker({
                daysOfWeekDisabled: this.settings.daysOfWeekDisabled,
                format: this.settings.format,
                locale: $('html').attr('lang'),
                minDate: this.settings.minDate ? this.settings.minDate : false,
                maxDate: this.settings.maxDate,
                disabledHours: this.settings.disabledHours,
                defaultDate: this.settings.useDefaultDate ? moment().add(1, 'day') : false,
                useCurrent: false,
                tooltips: this.settings.tooltips,
                sideBySide: true,
                allowInputToggle: true,
                stepping: 5,
                icons: {
                    previous: 'ai ai-menu-left brand-primary',
                    next: 'ai ai-menu-right brand-primary'
                }
            });
        },
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
            } else {
                $.data(this, 'plugin_' + pluginName).init();
            }
        });
    };
})(jQuery, moment);
